// Cola de envíos offline para el check-in del Punto Limpio. Se usa localStorage
// (los payloads son JSON pequeños, sin ficheros) para que, si el dispositivo se
// queda sin conexión dentro del propio Punto Limpio, la visita quede guardada en
// el navegador y se sincronice automáticamente en cuanto vuelva la señal.
const QUEUE_KEY = "sfh_puntolimpio_offline_queue";

export function getQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]");
  } catch {
    return [];
  }
}

function saveQueue(items) {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(items));
}

export function enqueueCheckin(payload) {
  const entry = {
    localId: `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    payload,
    createdAt: new Date().toISOString(),
  };
  saveQueue([...getQueue(), entry]);
  return entry;
}

export function removeFromQueue(localId) {
  saveQueue(getQueue().filter((item) => item.localId !== localId));
}

export function isNetworkError(err) {
  return !err?.response && !!err?.request;
}

// Intenta reenviar cada elemento pendiente. Se detiene en el primer fallo de red
// (seguimos sin conexión) o si el servidor está limitando peticiones (429, se
// reintentará más tarde), pero continúa si un elemento concreto fue rechazado por
// validación (422/400), para no bloquear el resto de la cola con un dato inválido.
export async function flushQueue(submitFn, { onItemSynced } = {}) {
  let synced = 0;
  for (const item of getQueue()) {
    try {
      const result = await submitFn(item.payload);
      removeFromQueue(item.localId);
      synced += 1;
      onItemSynced && onItemSynced(item, result);
    } catch (err) {
      if (isNetworkError(err) || err?.response?.status === 429) break;
      removeFromQueue(item.localId);
    }
  }
  return { synced, remaining: getQueue().length };
}
